import { IOptionSection, Categories, IOption } from "../models/IOption";

interface IGetOptionsProps {
  Options: IOptionSection;
  OnChange: (option: IOption, checked: boolean) => void;
}

function createMarkdownHeader(title: string, description: string, quoteTotal: number) {
  let header: string = ``; // let's leave this out unless we need it `<#MD>\n\n`;
  header += `# ${title}
  
## Quote Total

$${quoteTotal}.00

## Description

${description}
`;
  return header;
}

function createMarkdownContent(options: IOption[]) {
  let content: string = "";
  let optCategories: Categories[] = [];

  for (let i = 0; i < options.length; i++) {
    if (!optCategories.includes(options[i].Category)) {
      optCategories.push(options[i].Category);
    }
  }

  for (let i = 0; i < optCategories.length; i++) {
    let catOptions: IOption[] = options.filter(o => o.Category === optCategories[i]);
    content += `## ${Categories[optCategories[i]]}\n\n`;

    for (let j = 0; j < catOptions.length; j++) {
      content += `- ${catOptions[j].Description}`;

      if (catOptions[j].Price) {
        content += `\n  - $${catOptions[j].Price}.00`;
      }

      content += `\n`;
    }
    content += `\n`;
  }
  return content;
}

export function GetMarkdown(title: string, description: string, quoteTotal: number, options: IOption[]) {
  return `${createMarkdownHeader(title, description, quoteTotal)}
${createMarkdownContent(options)}
  `;
}

export function GetAPIMarkdown(title: string | undefined, description: string, urls: string, errorMessage: string, customers: string) {
  return (
    (title ? "# " + title + "\n\n## Description\n\n" : "") +
    `${description}` +
    (urls ? `\n\n## URLS\n\n${urls}` : "") +
    (errorMessage ? `\n\n## Error Message\n\n${errorMessage}` : "") +
    (customers ? `\n\n## Affected Customers\n\n${customers}` : "")
  );
}

export const getTotalPrice = (options: IOption[]): number => {
  let newTotal: number = 0;
  for (let i = 0; i < options.length; i++) {
    let option = options[i];
    if (option.Price && option.Selected) {
      newTotal += option.Price;
    }
  }
  return newTotal;
};

export const resetOptions = (opts: IOption[]): IOption[] => {
  let newOpts = [];
  for (let i = 0; i < opts.length; i++) {
    newOpts.push({ ...opts[i], Selected: false });
  }
  return newOpts;
};

export const getSelectedOptions = (opts: IOption[]): IOption[] => {
  let selectedOpts = [];
  for (let i = 0; i < opts.length; i++) {
    if (opts[i].Selected) {
      selectedOpts.push(opts[i]);
    }
  }
  return selectedOpts;
};
